// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dashboard {
  position: fixed;
  left: -4rem;
  width: 100vw;
  height: 100%;
  overflow-y: auto;
  background: #fff;
}
.Dashboard.loading .Widget {
  visibility: hidden;
}
.Dashboard .Widget {
  overflow: visible !important;
  transition: box-shadow 0.5s;
  border-radius: var(--bs-border-radius);
}
.Dashboard .Widget .Widget-Content {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden !important;
}
.Dashboard .Widget .Controls {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 100;
  color: #b1b1b1;
}
.Dashboard .Widget .Controls .Control.DragHandle {
  cursor: pointer;
}
.Dashboard .Widget .Controls .Control.SettingsButton {
  cursor: pointer;
}
.Dashboard .Widget .Controls,
.Dashboard .Widget .react-resizable-handle {
  opacity: 0;
  transition: opacity 0.2s;
  transition-delay: 0.5s;
}
.Dashboard .Widget.deleting, .Dashboard .Widget:hover {
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
}
.Dashboard .Widget.deleting .Controls,
.Dashboard .Widget.deleting .react-resizable-handle, .Dashboard .Widget:hover .Controls,
.Dashboard .Widget:hover .react-resizable-handle {
  opacity: 1;
}

.AddWidgetButton {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  position: fixed;
  right: 2rem;
  bottom: 2rem;
}
.AddWidgetButton, .AddWidgetButton:active, .AddWidgetButton:focus {
  box-shadow: -0.25rem 0.15rem 0.75rem rgba(0, 0, 0, 0.5) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/styles.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AACF;AACI;EACE,kBAAA;AACN;AAEE;EACE,4BAAA;EACA,2BAAA;EACA,sCAAA;AAAJ;AACI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;AACN;AACI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;AACN;AACQ;EACE,eAAA;AACV;AACQ;EACE,eAAA;AACV;AAGI;;EAEE,UAAA;EACA,wBAAA;EACA,sBAAA;AADN;AAGI;EAEE,uCAAA;AAFN;AAGM;;;EAEE,UAAA;AAAR;;AAMA;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAHF;AAIE;EAGE,kEAAA;AAJJ","sourcesContent":[".Dashboard {\n  position: fixed;\n  left: -4rem;\n  width: 100vw;\n  height: 100%;\n  overflow-y: auto;\n  background: #fff;\n  &.loading {\n    .Widget {\n      visibility: hidden;\n    }\n  }\n  .Widget {\n    overflow: visible !important;\n    transition: box-shadow 0.5s;\n    border-radius: var(--bs-border-radius);\n    .Widget-Content {\n      position: relative;\n      width: 100%;\n      height: 100%;\n      overflow: hidden !important;\n    }\n    .Controls {\n      position: absolute;\n      top: 0;\n      right: 0;\n      z-index: 100;\n      color: #b1b1b1;\n      .Control {\n        &.DragHandle {\n          cursor: pointer;\n        }\n        &.SettingsButton {\n          cursor: pointer;\n        }\n      }\n    }\n    .Controls,\n    .react-resizable-handle {\n      opacity: 0;\n      transition: opacity 0.2s;\n      transition-delay: 0.5s;\n    }\n    &.deleting,\n    &:hover {\n      box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);\n      .Controls,\n      .react-resizable-handle {\n        opacity: 1;\n      }\n    }\n  }\n}\n\n.AddWidgetButton {\n  width: 3.5rem;\n  height: 3.5rem;\n  border-radius: 50%;\n  position: fixed;\n  right: 2rem;\n  bottom: 2rem;\n  &,\n  &:active,\n  &:focus {\n    box-shadow: -0.25rem 0.15rem 0.75rem rgba(0, 0, 0, 0.5) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
